const accordion = () => {
    let accordionTrigger = document.querySelectorAll('[data-accordion]');
    let accordionContent = document.querySelectorAll('.accordion');

    if (!accordionTrigger || !accordionContent) return;

    // loop through accaccordionContent, get their height, add as data-height and set the css heioght to 0

    accordionContent.forEach(content => {
        const h = content.offsetHeight;
        content.dataset.height = h;       // store original height
        content.style.height = '0px';     // collapse initially
        content.style.overflow = 'hidden'; // ensure content doesn’t overflow
        content.style.transition = 'height 0.3s ease'; // smooth expand/collapse
    });


    let close = (trigger, element, hideElement) => {
        element.style.height = '0px';
        trigger.innerHTML = 'Read more';
        hideElement.style.display = 'block';
    };
    let open = (trigger, element, hideElement) => {
        element.style.height = `${element.dataset.height}px`;
        hideElement.style.display = 'none';
        trigger.innerHTML = 'Show less';
    };

    accordionTrigger.forEach((trigger, index) => {
        trigger.setAttribute('data-expanded', 'false');
        trigger.addEventListener('click', (e) => {
            let thisId = trigger.getAttribute('data-accordion');
            let element = document.getElementById(thisId);
            let hideElement = document.querySelector('[data-hide="' + thisId + '"]');

            if (trigger.getAttribute('data-expanded') === 'false') {
                trigger.setAttribute('data-expanded', 'true');
                open(trigger, element, hideElement);
            } else {
                trigger.setAttribute('data-expanded', 'false');
                close(trigger, element, hideElement);
            }
        });
    });
}

export default accordion;